/**
 * The encryption caching system is set up only to be accessed
 * during a decryption request. The ID of the EncryptedData object
 * represents where the item is stored to be later accessed. This
 * cache is cleared when a user signs off the system.
 */
const storagePath = 'encryption__';
const cacheEncryptionData = (id, data) => {
    if (data === null || data === undefined)
        return;
    const ls = window.localStorage;
    const dataString = JSON.stringify(data);
    return ls.setItem(`${storagePath}__${id}`, dataString);
};
const getEncryptionCachedData = (id) => {
    const ls = window.localStorage;
    const item = ls.getItem(`${storagePath}__${id}`);
    if (!item)
        return null;
    try {
        return JSON.parse(item);
    }
    catch (error) {
        ls.removeItem(`${storagePath}__${id}`);
        console.error(`Removed corrupted encryption cache data for id: ${id}`, item, error);
        return null;
    }
};
const clearEncryptionCache = () => {
    const ls = window.localStorage;
    Object.keys(ls)
        .filter((item) => item.includes(storagePath))
        .forEach((item) => ls.removeItem(item));
};

export { cacheEncryptionData, clearEncryptionCache, getEncryptionCachedData };
